import React from "react";
import { Stack, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";
import { TemplateSelectInputProps, NOTE_TEMPLATES } from "./PatientNotesConstants";

const StyledTemplateChip = styled(Chip)(({ theme }) => ({
  fontFamily: "Lato",
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: 12,
  color: theme.palette.common.white,
  paddingLeft: "0.5rem",
  paddingRight: "0.5rem",
  marginLeft: "0.5rem",
  borderRadius: "0.5rem",
  backgroundColor: theme.palette.primary.main,
  "&.MuiChip-outlined": {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    backgroundColor: "transparent",
  },
  "&:hover": {
    backgroundColor: theme.palette.primary.light,
  },
  "&.MuiChip-outlined:hover": {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
}));

// Chips implementation
export const PatientNotesTemplateInputChips: React.FC<TemplateSelectInputProps> = React.memo((p) => {
  const { value, onChange, onTemplateSelect, disabled } = p;

  const handleSelect = (next: string) => {
    onChange(next);
    if (next) {
      const selectedTemplate = NOTE_TEMPLATES.find((t) => t.id === next);
      onTemplateSelect(selectedTemplate || null);
    } else {
      onTemplateSelect(null);
    }
  };

  return (
    <Stack direction="row" alignItems="center" gap={0.5} flexWrap="wrap">
      <StyledTemplateChip
        label="None"
        variant={value ? "outlined" : "filled"}
        onClick={disabled ? undefined : () => handleSelect("")}
        disabled={disabled}
        clickable={!disabled}
        size="small"
      />
      {NOTE_TEMPLATES.map((t) => {
        const selected = value === t.id;
        return (
          <StyledTemplateChip
            key={t.id}
            label={t.title}
            variant={selected ? "filled" : "outlined"}
            onClick={disabled ? undefined : () => handleSelect(t.id)}
            disabled={disabled}
            clickable={!disabled}
            size="small"
          />
        );
      })}
    </Stack>
  );
});

PatientNotesTemplateInputChips.displayName = "PatientNotesTemplateInputChips";
